import * as actions from "../constants/actionTypes";
import * as utilsClient from "../utils/client";
import * as utils from "../utils/utils";

const initialState = {
    clients: [],
    loading: false,
    saving: false,
    deleting: false
};

export default function client(state = initialState, action) {
    let newState = Object.assign({}, state);

    switch (action.type) {
        case actions.LOADING_CLIENT:
            newState.loading = true;
            break;

        case actions.SAVING_CLIENT:
            newState.saving = true;
            break;

        case actions.RECEIVED_CLIENTS:
            newState.clients = utils.mapById(utilsClient.flattenCurrency(action.payload));
            newState.loading = false;
            break;

        case actions.SAVED_CLIENT:
            let found = false;

            for (let i = 0; i < newState.clients.length; i++) {
                if(newState.clients[i].id === action.payload.id){
                    found = true;

                    newState.clients[i] = action.payload;
                }
            }

            if(!found) {
                newState.clients.add(
                    action.payload
                );
            }

            newState.clients = utils.mapById(utilsClient.flattenCurrency(newState.clients));
            newState.loading = false;
            newState.saving = false;
            break;

        case actions.ERROR_SAVING_CLIENTS:
            newState.loading = false;
            newState.saving = false;
            break;

        case actions.DELETING_CLIENT:
            newState.deleting = true;
            break;

        case actions.DONE_DELETING_CLIENT:
            newState.deleting = false;
            break;

        default: break;
    }
    return newState;
}



// WEBPACK FOOTER //
// ./src/reducers/client.js